module.exports = __webpack_public_path__ + "img/license_disk_registration.a53bf41e.png";